var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};
site.search = {};
site.umsogn = {};
site.reiknivelar = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;


site.umsogn.init = function() {
	$umsogn = $("#umsogn");
	$umsogn.dialog({
		autoOpen:false,
		modal:true,
		resizable: false,
		fluid:true,
		width:"auto",
		height: "auto",
		maxWidth: "770px",
		dialogClass: "formDialog",
		show: { effect: "blind", duration: 400 },
		hide: { effect: "blind", duration: 400 }
	});

	$umsogn.find(".close" ).click(function() {
		$umsogn.dialog( "close" );
	});
	$( ".dialog" ).click(function(e) {
		$umsogn.dialog( "open" );
		e.preventDefault();
	});
}
// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};
site.reiknivelar.init = function() {
	$input = $('#reiknivelar .upphaed');
	$r = $('#reiknivelar #results');
};
site.reiknivelar.formatInput = function(number) {
	/*var number = number.toFixed(2) + '';*/
	var x = number.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + '.' + '$2');
	}
	return x1 + x2;
};

site.reiknivelar.maki = function() {
	$input = $('#reiknivelar .upphaed');
	$r = $('#reiknivelar #results');
	var oldValue = $input.val();
	$input.val(site.reiknivelar.formatInput($input.val()));

	$input.on('keyup',function() {
		var val = $(this).val();
		if(val == '' || val.length == 0) {
			val = '0';
		}
		var value2 = parseInt(val.split('.').join(""));
		val = value2;
		if(oldValue != value2) {
			oldValue = value2;
			$input.val(val.toLocaleString('de'));
		}

		var skylda = 0.33333334;
		var e = val/2;
		var ee = e*skylda;
		var te = e-ee;
		$r.find('.eignHjona,.eignHjonaTotal').text(formatNumbers(Math.ceil(e)));
		$r.find('.radstafaHjona').text(formatNumbers(Math.ceil(ee)));
		$r.find('.eignHjonaErdaskra').text(formatNumbers(Math.ceil(te)));
		$r.find('.eignHjonaSkylda').text(formatNumbers(Math.ceil(ee)));
		$r.find('.eignHjonaErdaskraSkylda').text(formatNumbers(Math.ceil(te*skylda)));
		$r.find('.eignHjonaErdaskraMaki').text(formatNumbers(Math.ceil(ee+(te*skylda))));
		$r.find('.eignHjonaErdaskraBarn').text(formatNumbers(Math.ceil(te*(1-skylda))));
		$r.find('.eignHjonaTotalBarn').text(formatNumbers(Math.ceil(e*(1-skylda))));

	});
	$input.keyup();
};
site.reiknivelar.barna = function() {
	$input = $('#reiknivelar .upphaed');
	$r = $('#reiknivelar #results');
	var oldValue = $input.val();
	$input.val(site.reiknivelar.formatInput($input.val()));


	$input.on('keyup',function() {
		var val = $(this).val();
		if(val == '' || val.length == 0) {
			val = '0';
		}
		var value2 = parseInt(val.split('.').join(""));
		val = value2;
		if(oldValue != value2) {
			oldValue = value2;
			$input.val(val.toLocaleString('de'));
		}

		var skylda = 0.33333334;
		var skyldaInvert = 1-skylda;
		var e = val/2;
		var ee = e*skylda;
		var te = e-ee;
		var n24 = val-e-((val-e)/3);
		$r.find('.eignHjona,.eignHjonaTotal').text(formatNumbers(Math.ceil(e)));
		$r.find('.kaupmEign').text(formatNumbers(Math.ceil(val)));

		$r.find('.eignBarnaMaki').text(formatNumbers(Math.ceil(e)));
		$r.find('.eignBarnaMaki1').text(formatNumbers(Math.ceil(e)));
		$r.find('.eignBarnaMaki2').text(formatNumbers(0));
		$r.find('.eignBarnaMaki3').text(formatNumbers(Math.ceil(e)));

		$r.find('.eignBarnaRadstofun3').text(formatNumbers(Math.ceil((val-e)/3)));

		$r.find('.eignBarnaTotal').text(formatNumbers(Math.ceil(val-e)));
		$r.find('.eignBarnaTotal1').text(formatNumbers(Math.ceil(val-e)));
		$r.find('.eignBarnaTotal2').text(formatNumbers(Math.ceil(val)));
		$r.find('.eignBarnaTotal3').text(formatNumbers(Math.ceil(n24)));

		$r.find('.eignBarnaMakiTotal').text(formatNumbers(Math.ceil(ee)));
		$r.find('.eignBarnaMakiTotal1').text(formatNumbers(Math.ceil(ee+e)));
		$r.find('.eignBarnaMakiTotal2').text(formatNumbers(Math.ceil(val/3)));
		$r.find('.eignBarnaMakiTotal3').text(formatNumbers(Math.ceil((n24/3)+e)));

		$r.find('.eignBarnaBarnaTotal').text(formatNumbers(Math.ceil((val-e)*skyldaInvert)));
		$r.find('.eignBarnaBarnaTotal1').text(formatNumbers(Math.ceil(val-(ee+e))));
		$r.find('.eignBarnaBarnaTotal2').text(formatNumbers(Math.ceil(val-(val/3))));
		$r.find('.eignBarnaBarnaTotal3').text(formatNumbers(Math.ceil(val-((n24/3)+e))));
	});
	$input.keyup();
};

site.reiknivelar.sambud = function() {
	$form = $('#reiknivelar form');
	$input = $form.find('input[type="text"]');
	$upphaed = $form.find('.upphaed');
	var oldValue = $upphaed.val();
	$r = $('#reiknivelar #results');
	$re = $('#reiknivelar .explain');
	$upphaed.val(site.reiknivelar.formatInput($upphaed.val()));


	$input.on('keyup',function() {
		var val = $upphaed.val();
		if(val == '' || val.length == 0) {
			val = '0';
		}
		var value2 = parseInt(val.split('.').join(""));
		val = value2;
		if(oldValue != value2) {
			oldValue = value2;
			$upphaed.val(val.toLocaleString('de'));
		}

		var hlutur = $form.find('.hlutur').val();
		hlutur = hlutur.replace(',','.');

		var skylda = 0.33333334;
		var e = val*(hlutur/100);
		var ee = e*skylda;
		var te = e-ee;

		$r.find('.eignThin').text(formatNumbers(Math.ceil(e)));
		$r.find('.eignThinE').text(formatNumbers(Math.ceil(e)));
		$r.find('.eingMaka').text(formatNumbers(Math.ceil(val-e)));
		$r.find('.eingMakaE').text(formatNumbers(Math.ceil(val-e)));
		$r.find('.radstofunE').text(formatNumbers(Math.ceil(ee)));

		$r.find('.eignTotal,.totalBarna').text(formatNumbers(Math.ceil(e)));
		$r.find('.eignTotalE').text(formatNumbers(Math.ceil(e-ee)));

		$r.find('.totalMakiE').text(formatNumbers(Math.ceil(ee)));
		$r.find('.totalBarnaE').text(formatNumbers(Math.ceil((e-ee)*(1-skylda))));

		$re.find('.sambudExplain').text(formatNumbers(Math.ceil(val-e)));
		$re.find('.sambudExplain2').text(formatNumbers(Math.ceil((val-e)+ee)));

	});
	$input.keyup();
};

site.reiknivelar.saga = function() {
	$form = $('#reiknivelar form');
	$input = $form.find('input[type="text"]');
	$upphaed = $form.find('.upphaed');
	var oldValue = $upphaed.val();
	$upphaed.val(site.reiknivelar.formatInput($upphaed.val()));

	$sa = $('#reiknivelar .skiptingA');
	$sb = $('#reiknivelar .skiptingB');
	$sc = $('#reiknivelar .skiptingAB');
	$input.on('keyup',function() {
		var val = $form.find('.upphaed').val();
		if(val == '' || val.length == 0) {
			val = '0';
		}
		var value2 = parseInt(val.split('.').join(""));
		val = value2;
		if(oldValue != value2) {
			oldValue = value2;
			$upphaed.val(val.toLocaleString('de'));
		}

		var barna =  parseInt($form.find('.barna').val());
		var barnb =  parseInt($form.find('.barnb').val());
		var barnc =  parseInt($form.find('.barnc').val());
		var skylda = 0.33333334;
		var skyldaInvert = 1-skylda;
		var e = val/2;
		var ee = e*skylda;
		var te = e-ee;

		var b22 = (barna > 0) ? ((e-(e/3))/(barna+barnc))/barna*barna: 0;
		var b23 = (barna > 0) ? ((e-(e/3))/(barna+barnc)): 0;

		$sa.find('.sagaEignB').text(formatNumbers(Math.ceil(e)));
		$sa.find('.sagaTotalEignB').text(formatNumbers(Math.ceil(e)));
		$sa.find('.sagaTotalBeftirA').text(formatNumbers(Math.ceil(e/3)));
		$sa.find('.sagaTotalBarnA').text(formatNumbers(Math.ceil(b22)));
		$sa.find('.sagaTotalBarnA2').text(formatNumbers(Math.ceil(b23)));
		$sa.find('.sagaTotalBarnA3').text(formatNumbers(Math.ceil(0)));

		var amount = e+ (e/3);
		var amount2 = amount/2;
		var c36 = (barnc == 0) ? 0 : (amount/(barnb+barnc)*barnc/barnc);
		var c37 = (barnb == 0) ? 0 : (amount/(barnb+barnc)*barnb/barnb);
		$('#reiknivelar .sagaIntro3Amount').text(formatNumbers(Math.ceil(amount)));
		$sb.find('.sagaB1Eign').text(formatNumbers(Math.ceil(amount)));
		$sb.find('.sagaB1total1').text(formatNumbers(Math.ceil(0)));
		$sb.find('.sagaB1total2').text(formatNumbers(Math.ceil(c36)));
		$sb.find('.sagaB1total3').text(formatNumbers(Math.ceil(c37)));

		var f37 = (barnc == 0) ? 0 : (amount2 - (amount2/3))/(barnb+barnc);
		var f38 = (barnb == 0) ? 0 : (amount2 - (amount2/3))/(barnb+barnc);
		$sb.find('.sagaB2Eign').text(formatNumbers(Math.ceil(amount2)));
		$sb.find('.sagaB2total1').text(formatNumbers(Math.ceil(amount2/3)));
		$sb.find('.sagaB2total2').text(formatNumbers(Math.ceil(0)));
		$sb.find('.sagaB2total3').text(formatNumbers(Math.ceil(f37)));
		$sb.find('.sagaB2total4').text(formatNumbers(Math.ceil(f38)));
		$sb.find('.sagaB2total5').text(formatNumbers(Math.ceil(0)));

		$('#reiknivelar .sagaIntro4Amount').text(formatNumbers(Math.ceil(val)));

		var c51 = (b22*barna)+((b23+c36)*barnc);
		$sc.find('.sagaAB1total1').text(formatNumbers(Math.ceil(b22)));
		$sc.find('.sagaAB1total2').text(formatNumbers(Math.ceil(b23+c36)));
		$sc.find('.sagaAB1total3').text(formatNumbers(Math.ceil(c51)));
		$sc.find('.sagaAB1total4').text(formatNumbers(Math.ceil(c37)));
		$sc.find('.sagaAB1total5').text(formatNumbers(Math.ceil(c37*barnb)));
		$sc.find('.sagaAB1total6').text(formatNumbers(Math.ceil(c51+(c37*barnb))));

		var f51 = (b22*barna)+((b23+f37)*barnc);
		var f54 = amount2+(amount2/3);
		$sc.find('.sagaAB2total1').text(formatNumbers(Math.ceil(b22)));
		$sc.find('.sagaAB2total2').text(formatNumbers(Math.ceil(b23+f37)));
		$sc.find('.sagaAB2total3').text(formatNumbers(Math.ceil(f51)));
		$sc.find('.sagaAB2total4').text(formatNumbers(Math.ceil(f38)));
		$sc.find('.sagaAB2total5').text(formatNumbers(Math.ceil(f38*barnb)));
		$sc.find('.sagaAB2total6').text(formatNumbers(Math.ceil(f54)));
		$sc.find('.sagaAB2total7').text(formatNumbers(Math.ceil(f51+(f38*barnb)+f54)));


	});
	$input.keyup();
};

function formatNumbers(value) {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

// Init search dropdown
site.search.init = function() {
	$navbar = $('.navbar-utfor');
	$navbar.find('.gler').click(function() {
		$this = $(this);
		if($this.hasClass('open')) {
			$this.toggleClass('open');
			$navbar.find('.searchDrop').css('maxHeight',0);

			setTimeout( function() {
				$navbar.find('.searchDrop').removeClass('open').removeAttr('style');
			}, 600);
		}
		else {
			$this.toggleClass('open');
			$navbar.find('.searchDrop').toggleClass('open').find('#q').focus();;
		}
	});
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	$('.children', '#mainmenu ').prepend('<a class="expand" href="#"><i class="fa fa-angle-left"></i></a>');
	$('.selectedLevel1','#mainmenu').addClass('down');
	if(document.addEventListener) {
		document.addEventListener("touchmove", ScrollStart, false);
		document.addEventListener("scroll", ScrollStart, false);
	}
	site.nav.bind();
	site.nav.appendStuff();
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu').bind('click', function(e) {
		e.preventDefault();

		var $parent = $(this).parent();
		$parent.toggleClass('down');
		/*
		var $ul = $this.siblings('ul');

		$ul.toggleClass('hide');
		$this.next().toggleClass('down');
		$this.toggleClass('down');
		e.preventDefault();
		*/
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
	}
	else {
		$(window).scrollTop(scrollPosition);
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};

// Append language to mobilemenu
site.nav.appendStuff = function() {
	var $divisions = $('ul:last', '.navbar-lang');
	var $search = $('#searchForm','.searchDrop');
	var $menu = $('ul.mmLevel1', '#mainmenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});
	var $searchHtml = $('<div class="mSearch"></div>');
	$searchHtml.append($search.clone());

	$menu.append($html);
	$menu.parent().prepend($searchHtml);
};

store.local.onCartBox = function($box, data) {
	$box.find('.showMore').effect("highlight", {color:"#ccc"}, 1000);
};
store.local.onInit = function() {
	var $body = $('body');
	if ($body.hasClass('checkout')) {
		var $g = $('.stepperContent.info_guest');
		$g.find('input').attr('autocomplete', 'off');
		$g.find('form').attr('autocomplete', 'off');
	}

	if ($('body').hasClass('checkout')) {
		$('#billing-billingSameAsShipping').change(function() {
			var $fieldset = $('#fieldset-billing').toggleClass('disabled');
			if ($fieldset.hasClass('disabled')) {
				$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
			}
			else {
				$fieldset.find('input:not(.checkbox)').attr('disabled', null);
			}
		}).change();

		$('ul.paymentTypeSelection li').click(function(){
			$(this).siblings().removeClass('selected');
			$(this).addClass('selected');
		});
	}



};

function ScrollStart() {
	var minScroll = 120;
	var fClass = 'scroll';
	var scrollTop = $(window).scrollTop();
	$navbar = $('.navbar-utfor');
	if (scrollTop > minScroll){
		$navbar.addClass(fClass);
	}else{
		$navbar.removeClass(fClass);
	}
}

function isFront() {

	return $('body').is('.frontpage');
}
function hasRight() {
	return $('body').is('.hideright');
}
function isCalendar() {
	return $('body').is('.calendar');
}

function smothScroll(){
	$('a[href*=#]:not([href=#])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-84
				}, 500);
				return false;
			}
		}
	});
}

// Run all the inits \o/
$(function() {
	site.nav.init();
	/*
	site.owl.init('#hero > ul', {
		loop:true,
		nav:true,
		autoplayHoverPause:true,
		navText:["",""],
		items: 1
	});
	*/

	site.owl.init('#adstadan > ul', {
		loop:true,
		items:6,
		margin:10,
		nav:true,
		navText:["",""],
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
				nav:true
			},
			768:{
				items:3,
				nav:false
			},
			991:{
				items:6,
				nav:true,
				loop:false
			}
		}


	});

	site.search.init();
	site.umsogn.init();
	smothScroll();

	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Open cart
	$('body').on('click', '#storeCart .showMore, #cartLay', function(e) {
		e.preventDefault();
		$('#storeCart,#cartLay').toggleClass('open');
		$('.cartBoxMedium img').responsiveImg();
	});

	// Open cart and scroll to top
	$('body').on('click', '#submitCart', function () {
		var $root = $('html, body');
		setTimeout(function () {
			$('#storeCart .miniCart .showMore').trigger('click');
		}, 500);
		setTimeout(function() {
			$('body').removeClass('cart-open');
		}, 5000);
		$root.animate({
			scrollTop: 0
		}, 500);
	});

	// Main table classes
	if(!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
		$('.table1', '#main').addClass('table table-striped');
	}

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);

	$('#employees .entryLabel').first().hide();
	$('#employees .entryValue').first().hide();


});
